import { render } from "./LoginPage_User.vue?vue&type=template&id=0ff0bfd5&scoped=true"
import script from "./LoginPage_User.vue?vue&type=script&lang=js"
export * from "./LoginPage_User.vue?vue&type=script&lang=js"

import "./LoginPage_User.vue?vue&type=style&index=0&id=0ff0bfd5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff0bfd5"]])

export default __exports__